const JSON_REGEXP = /[/+]json($|[^-\w])/i;
const BINARY_MIMES = ['multipart/encrypted', 'application/octet-stream'];
function getResponseType(contentTypeRaw) {
    let contentType = contentTypeRaw;
    if (typeof contentType === 'string') {
        contentType = [contentType];
    }
    if (contentType) {
        if (contentType.some(t => JSON_REGEXP.test(t))) {
            return 'json';
        }
        if (contentType.some(t => BINARY_MIMES.includes(t))) {
            return 'binary';
        }
    }
    return 'string';
}

export { getResponseType };
//# sourceMappingURL=getResponseType.mjs.map
